<div [class.example-box-modern]="(profileState | async).boxExampleStatus[name()]">
  <div class="content-box">
    <div *ngIf="(profileState | async).boxExampleStatus[name()]" class="example-badge">
      <i class="bi bi-info-circle"></i> Sample data
    </div>
    <ng-content></ng-content>
    <div *ngIf="(profileState | async).boxExampleStatus[name()]">
      <div class="example-footer" *ngIf="!((profileState | async).audit !== null && (profileState | async).audit.status)">
        <div class="example-footer-inner">
          <div class="example-footer-text">
            <i class="bi bi-lightning-charge-fill"></i>
            <span>Get <strong>real data</strong> with a full report</span>
          </div>
          <div class="example-footer-actions">
            <a routerLink="/payment/add" class="btn-unlock-sm">
              Unlock Report
            </a>
            <a class="btn-hide-example" (click)="setExampleStatus(false)">
              Hide sample
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
